import { Component, OnInit } from '@angular/core';
import { SsoService } from '../../services/auth_sso/auth_sso.service';

@Component({
  selector: 'app-sso-callback',
  template: `<p></p>`,
  standalone:true,
})
export class CallbackComponent implements OnInit {
  constructor(private authService: SsoService) {}

  async ngOnInit() {
    await this.authService.handleRedirectCallback();
  }
}
